<template>
    <loading v-if="isLoading"></loading>

    <transition v-else name="fade">
        <section v-cloak v-if="job" class="lc-single-job-page job">
            <div class="job__column">
                <information/>
                <tabs/>
            </div>
            <div v-if="isMobile === false" class="job__column">
                <comments/>
            </div>
        </section>
    </transition>
</template>
<script>
/* global app */
import { mapState } from 'vuex'
import Device from '../../mixins/deviceAware'
import Information from './Information'
import Tabs from './Tabs'
import Comments from './Comments/Comments'
import Loading from '../Global/Loading'

export default {
    mixins: [Device],

    props: {
        channelId: {
            type: Number,
            required: true
        },

        jobId: {
            type: Number,
            required: true
        }
    },

    data () {
        return {
            isLoading: true,
            csrfToken: app.csrfToken
        }
    },

    created () {
        Promise.all([
            this.$store.dispatch('job/fetchJob', this.jobId),
            this.$store.dispatch('channel/fetchChannel', this.channelId),
            this.$store.dispatch('channel/fetchMembers', this.channelId),
            this.$store.dispatch('tenant/fetchUsers')
        ]).then(() => {
            this.isLoading = false
        })

        Echo.private(`${app.currentTenant.id}_job_${this.jobId}`)
            .listen('JobWasRenamed', (e) => {
                this.$store.commit('job/SET_JOB', (e.job))
            })
            .listen('JobDueDateWasChanged', (e) => {
                this.$store.commit('job/SET_JOB', (e.job))
            })
            .listen('JobDescriptionWasUpdated', (e) => {
                this.$store.commit('job/SET_JOB', (e.job))
            })
            .listen('JobMemberWasAdded', (e) => {
                this.$store.commit('job/ADD_MEMBER', (e.member))
            })
            .listen('JobMemberWasRemoved', (e) => {
                this.$store.commit('job/REMOVE_MEMBER', (e.member_id))
            })
            .listen('JobWasReinstated', (e) => {
                this.$store.commit('job/SET_JOB', (e.job))
            })
            .listen('JobWasArchived', (e) => {
                this.$store.commit('job/SET_JOB', (e.job))
            })
    },

    computed: {
        ...mapState('job', ['job'])
    },

    components: {
        Loading,
        Information,
        Tabs,
        Comments
    }
}
</script>
